import type { Module } from '@/shared/schemas';

/**
 * Static module catalog (v1).
 * This will be replaced by a Rust API service in v2.
 */
export const STATIC_CATALOG: readonly Module[] = [
  {
    id: 'knowledge',
    name: 'knowledge.hey.sh',
    url: 'https://heysh-knowledge.web.app',
    description:
      'Shared knowledge base and documentation. The home for reference materials and guides.',
    status: 'active',
    visibility: 'public',
    tags: ['docs', 'reference'],
  },
  {
    id: 'communication',
    name: 'communication.hey.sh',
    url: 'https://heysh-communication.web.app',
    description: 'Cross-channel messaging experiments. Email, SMS, and notification patterns.',
    status: 'alpha',
    visibility: 'members',
    tags: ['agent', 'messaging'],
  },
  {
    id: 'logistic',
    name: 'logistic.hey.sh',
    url: 'https://heysh-logistic.web.app',
    description: 'Routing and logistics coordination. Last-mile delivery optimization.',
    status: 'active',
    visibility: 'members',
    tags: ['infra', 'routing'],
  },
  {
    id: 'pattern',
    name: 'pattern.hey.sh',
    url: 'https://heysh-pattern.web.app',
    description: 'UI component library and design patterns. Shared primitives across modules.',
    status: 'active',
    visibility: 'public',
    tags: ['ui', 'design'],
  },
  {
    id: 'vector',
    name: 'vector.hey.sh',
    url: 'https://heysh-vector.web.app',
    description: 'Vector storage and semantic search. Embeddings infrastructure.',
    status: 'alpha',
    visibility: 'members',
    tags: ['data', 'infra', 'research'],
  },
  {
    id: 'storage',
    name: 'storage.hey.sh',
    url: 'https://heysh-storage.web.app',
    description: 'File storage and asset management. Simple object storage interface.',
    status: 'alpha',
    visibility: 'public',
    tags: ['infra', 'data'],
  },
  {
    id: 'scheduling',
    name: 'scheduling.hey.sh',
    url: 'https://heysh-scheduling.web.app',
    description: 'Calendar and scheduling coordination. Availability and booking patterns.',
    status: 'alpha',
    visibility: 'members',
    tags: ['agent', 'ui'],
  },
  {
    id: 'routing',
    name: 'routing.hey.sh',
    url: 'https://heysh-routing.web.app',
    description: 'Route optimization and mapping. Geographic pathfinding experiments.',
    status: 'alpha',
    visibility: 'members',
    tags: ['infra', 'research'],
  },
  {
    id: 'photo',
    name: 'photo.hey.sh',
    url: 'https://heysh-photo.web.app',
    description: 'Image processing and management. Photo workflows and transformations.',
    status: 'alpha',
    visibility: 'public',
    tags: ['ui', 'data'],
  },
  {
    id: 'preso',
    name: 'preso.hey.sh',
    url: 'https://heysh-preso.web.app',
    description: 'Presentation builder. Minimal slides from markdown.',
    status: 'alpha',
    visibility: 'public',
    tags: ['ui', 'research'],
  },
  {
    id: 'print',
    name: 'print.hey.sh',
    url: 'https://heysh-print.web.app',
    description: 'Print-ready document generation. PDFs, invoices, and formatted output.',
    status: 'alpha',
    visibility: 'members',
    tags: ['infra'],
  },
  {
    id: 'mobile',
    name: 'mobile.hey.sh',
    url: 'https://heysh-mobile.web.app',
    description: 'Mobile-first experiments. Native and PWA prototypes.',
    status: 'alpha',
    visibility: 'members',
    tags: ['ui', 'research'],
  },
] as const;
